"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSecondaryNav = void 0;
var React = require("react");
var ApSecondaryNav_styles_1 = require("./ApSecondaryNav.styles");
exports.ApSecondaryNav = function (_a) {
    var left = _a.left, right = _a.right, props = __rest(_a, ["left", "right"]);
    return (React.createElement(ApSecondaryNav_styles_1.Container, __assign({}, props),
        React.createElement(ApSecondaryNav_styles_1.Wrapper, null,
            left,
            React.createElement(ApSecondaryNav_styles_1.ControlsWrapper, null, right))));
};
//# sourceMappingURL=ApSecondaryNav.js.map